import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseurl } from "../CoocpeatHome";
import "../Cart/cartitems.css";
import "../OrderFlow/OrderPage.css";

function PaymentSuccess() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [orderId, setOrderId] = useState(null);

  const verifyAndPlaceOrder = async () => {
    try {
      const placeOrder = await axios.post(`${baseurl}products/placeorder`, {
        products: JSON.parse(localStorage.getItem("orderProducts")),
        totalPrice: localStorage.getItem("orderAmount"),
        customerDetails: JSON.parse(localStorage.getItem("customerDetails")),
        deliveryType: localStorage.getItem("deliveryType"),
        deliveryDate: localStorage.getItem("deliveryDate"),
      });

      if (placeOrder.status === 201) {
        setOrderId(placeOrder.data.orderId);
      } else {
        alert("Order placement failed");
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
    setLoading(false);
  };

  useEffect(() => {
    verifyAndPlaceOrder();
  }, []);

  if (loading) {
    return (
      <div className="backcolour" style={{ padding: 30, textAlign: "center" }}>
        <h2>Finalising your order...</h2>
      </div>
    );
  }

  return (
    <div className="backcolour" style={{ padding: 20 }}>
      <div
        style={{
          background: "#fff",
          padding: 25,
          borderRadius: 10,
          textAlign: "center",
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/845/845646.png"
          alt="success"
          style={{ width: 80, marginBottom: 15 }}
        />

        <h2 style={{ color: "green", marginBottom: 5 }}>Order Placed!</h2>
        <p style={{ color: "#444" }}>
          Thank you for your purchase. Your order has been successfully placed.
        </p>

        {orderId && (
          <div
            style={{
              background: "#f7f7f7",
              padding: 15,
              borderRadius: 8,
              marginTop: 15,
              fontSize: 15,
            }}
          >
            <strong>Order ID:</strong> {orderId}
          </div>
        )}

        <button
          onClick={() => navigate("/")}
          style={{
            marginTop: 20,
            padding: "10px 20px",
            background: "#0ea5a4",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontSize: 16,
            cursor: "pointer",
          }}
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
}

export default PaymentSuccess;
